export default __webpack_public_path__ + "static/media/icon-activity-centre.96d06bb6.svg";